import { createAsyncThunk } from '@reduxjs/toolkit';

import type { IEntity } from '@/Module/Core/Model/DataModel';
import type { IGetPooyanPlayerTokenResponse } from '@/Module/Lesson/Model/ApiModel';
import { LessonService } from '@/Module/Lesson/Service';

export const getPooyanPlayTokenAction = createAsyncThunk<IGetPooyanPlayerTokenResponse, IEntity['id']>(
  'video/getPooyanPlayToken',
  async (entityId, { signal }) => {
    return LessonService.getPooyanPlayerToken(entityId, signal).then(
      ({
        data: {
          data: { data },
        },
      }) => data,
    );
  },
);
